<!--
 * @Author: 黄昱森
 * @LastEditors: 黄昱森
 * @Description: 
-->
<template>
  <div class="lc-list" :style="styles">
    <div class="lc-list-header">
      <slot name="header" />
    </div>
    <div class="lc-list-body">
      <slot />
    </div>
  </div>
</template>

<script>
import { cloneDeep } from 'lodash'
export default {
  name: 'LcList',
  props: {
    indexWidth: {
      type: String,
      default: ''
    },
    interval: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      value: []
    };
  },
  computed: {
    styles() {
      return {
        '--list-item-interval': this.interval,
        '--list-item-index-width': this.indexWidth
      }
    }
  },
  created() {
    // preset
  },
  mounted() {
    // preset
  },
  methods: {
    getValue() {
      return this.$children[this.$children.length - 1].$children.map(child => cloneDeep(child.formModel))
    }
  }
};
</script>
